import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueFire, VueFireAuth } from 'vuefire'
import { firebaseApp } from './services/firebase/config'

import App from './App.vue'
import router from './router'

// DM Sans self-hosted (tipografía del ecosistema — espejo del portal).
import '@fontsource/dm-sans/400.css'
import '@fontsource/dm-sans/500.css'
import '@fontsource/dm-sans/600.css'
import '@fontsource/dm-sans/700.css'
import './assets/styles/main.css'

// Registrar componentes de preguntas (OCP - Open/Closed Principle)
import { registerQuestionComponents } from './components/questions/registry'
registerQuestionComponents()

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()],
})

app.mount('#app')
